<div class="alert-container additional-message w-100">
  <div class="text-gray3 pb-0 standard">{{ offerSection()?.title }}</div>
  <div class="lead pb-0">
    {{ offerSection()?.content }}
  </div>
</div>
